import {
  Component,
  OnInit,
  Input,
  ViewChild,
  TemplateRef,
  ElementRef
} from "@angular/core";
import { CommonService, EmployeeService } from "../../../services";
import * as _ from "lodash";
import { FormControl } from "@angular/forms";
import { Observable } from "rxjs";
import swal from "sweetalert2";

@Component({
  selector: "menuMappingComponent",
  templateUrl: "./menuMapping.component.html",
  styleUrls: ["./menuMapping.scss"]
})
export class menuMappingComponent implements OnInit {
  menuList: any[];
  allMenus: any;
  master: any[];
  transaction: any[];
  report: any[];
  transBill: any[];
  transChallan: any[];
  transFol: any[];
  transEdit: any[];
  dailyReport: any[];
  followReport: any[];
  dailyHisReport: any[];
  notokReport: any[];
  allBranchRepReport: any[];
  appoinmentRepReport: any[];
  allBranchReport: any[];
  appoinmentReport: any[];
  management: any[];
  stockReport: any[];
  retReport: any[];
  cliReport: any[];
  salFolReport: any[];
  trackReport: any[];
  purchaseReport: any[];
  serviceReport: any[];
  soldReport: any[];
  doctorMenus: any[];
  telecallerMenus: any[];
  dstrReport: any[];

  employeeOption: Observable<any>;
  employeeCtrl = new FormControl();
  employeeList: any = [];
  employeeId: any;
  search: any;
  allMenuList = [];
  currentUserMenus: any[];
  fullMenus: any[];
  menuIds: any[];
  currentSelectedUserId: any;

  constructor(
    public commonService: CommonService,
    public employee: EmployeeService
  ) {
    this.getEmployeeList();
  }
  ngOnInit() {
    this.menuIds = [];
    this.getAllMenus();
    this.employeeOption = this.employeeCtrl.valueChanges
      .startWith("")
      .map(name => (name ? this.filterHa(name) : this.employeeList.slice()));
  }

  getAllMenus() {
    let that = this;
    this.commonService.getUserMenus().then(function (res: any) {
      if (res) {
        that.allMenuList = that.formatMenus(res.data);
      }
    });
  }

  formatMenus(res) {
    this.menuList = [];
    this.fullMenus = res;
    this.allMenus = res.filter(r => r.visible == 'true');//_.filter(res['visible']);
    this.allMenus = _.groupBy(this.allMenus, "parent");
    this.master = _.filter(this.allMenus["Master"]);
    this.transaction = _.filter(this.allMenus["Transaction"]);
    this.report = _.filter(this.allMenus["Report"]);
    // Transactions
    this.transBill = _.filter(this.allMenus["billTransaction"]);
    this.transChallan = _.filter(this.allMenus["ChaTransaction"]);
    this.transFol = _.filter(this.allMenus["FolTransaction"]);
    this.transEdit = _.filter(this.allMenus["Edit"]);
    // Reports
    this.dailyReport = _.filter(this.allMenus["dailyReport"]);
    this.followReport = _.filter(this.allMenus["folReport"]);
    this.dailyHisReport = _.filter(this.allMenus["dailyHistoryReport"]);
    this.notokReport = _.filter(this.allMenus["notokReport"]);
    this.allBranchReport = _.filter(this.allMenus["allBranchReport"]);
    this.appoinmentReport = _.filter(this.allMenus["appoinmentReport"]);
    this.management = _.filter(this.allMenus["Management"]);
    this.stockReport = _.filter(this.allMenus["stockReport"]);
    this.retReport = _.filter(this.allMenus["retReport"]);
    this.cliReport = _.filter(this.allMenus["clientReport"]);
    this.salFolReport = _.filter(this.allMenus["salesReport"]);
    this.trackReport = _.filter(this.allMenus["trackReport"]);
    this.purchaseReport = _.filter(this.allMenus["purchaseReport"]);
    this.serviceReport = _.filter(this.allMenus["serviceTracking"]);
    this.soldReport = _.filter(this.allMenus["soldReport"]);
    this.doctorMenus = _.filter(this.allMenus["Doctor"]);
    this.telecallerMenus = _.filter(this.allMenus["Telecaller"]);
    this.dstrReport = _.filter(this.allMenus["dstrReport"]);

    // Master sub-groups ----------->
    if (this.doctorMenus && this.doctorMenus.length) {
      this.master.push({ title: "Doctor", sub: this.doctorMenus, show: false, folderView: true });
    }
    if (this.telecallerMenus && this.telecallerMenus.length) {
      this.master.push({ title: "Telecaller", sub: this.telecallerMenus, show: false, folderView: true });
    }
    // -------------------->

    // Transactions- ----------->
    this.transaction.push({
      title: "Billing",
      sub: this.transBill,
      show: false,
      folderView: true
    });
    this.transaction.push({
      title: "Challan",
      sub: this.transChallan,
      show: false,
      folderView: true
    });
    this.transaction.push({
      title: "Followup",
      sub: this.transFol,
      show: false,
      folderView: true
    });
    this.transaction.push({
      title: "Edit",
      sub: this.transEdit,
      show: false,
      folderView: true
    });
    // ---------------->

    // Report--------------->
    this.report.push({
      title: "Track",
      sub: this.trackReport,
      show: false,
      folderView: true
    });
    this.report.push({
      title: "All Branch Report",
      sub: this.allBranchReport,
      show: false,
      folderView: true
    });
    this.report.push({
      title: "Branch Sales",
      sub: this.salFolReport,
      show: false,
      folderView: true
    });
    this.report.push({
      title: "Client Report",
      sub: this.cliReport,
      show: false,
      folderView: true
    });
    this.report.push({
      title: "Stock Report",
      sub: this.stockReport,
      show: false,
      folderView: true
    });
    this.report.push({
      title: "Purchase Report",
      sub: this.purchaseReport,
      show: false,
      folderView: true
    });
    this.report.push({
      title: "Service Track Report",
      sub: this.serviceReport,
      show: false,
      folderView: true
    });
    this.report.push({
      title: "Sold Report",
      sub: this.soldReport,
      show: false,
      folderView: true
    });
    this.report.push({
      title: "Return Report",
      sub: this.retReport,
      show: false,
      folderView: true
    });
    this.report.push({
      title: "Daily Report",
      sub: this.dailyReport,
      show: false,
      folderView: true
    });
    this.report.push({
      title: "Follow Report",
      sub: this.followReport,
      show: false,
      folderView: true
    });
    this.report.push({
      title: "Daily History Report",
      sub: this.dailyHisReport,
      show: false,
      folderView: true
    });
    this.report.push({
      title: "Not Ok Report Report",
      sub: this.notokReport,
      show: false,
      folderView: true
    });
    this.report.push({
      title: "Appointment Report",
      sub: this.appoinmentReport,
      show: false,
      folderView: true
    });

    this.report.push({
      title: "Management Report",
      sub: this.management,
      show: false,
      folderView: true
    });
    if (this.dstrReport && this.dstrReport.length) {
      this.report.push({ title: "DSTR", sub: this.dstrReport, show: false, folderView: true });
    }
    // -------------------->

    this.menuList.push({ title: "Master", sub: this.master, show: false });
    this.menuList.push({
      title: "Transactions",
      sub: this.transaction,
      show: false
    });
    this.menuList.push({ title: "Reports", sub: this.report, show: false });
    return this.menuList;
  }

  getEmployeeList() {
    // let that = this;
    this.commonService.getMenuMappingUserList().then((res: any) => {
      this.employeeList = res.data;
    });
  }

  changeCheckBox(row) {
    let flag = false;
    if (row.sub) {
      row.sub.map(res => {
        res['showMenu'] = !res['showMenu'];
        // if (res.sub) {
        //   this.changeCheckBox(res);
        // }
      });
    }
  }

  displayRef(item_id: number) {
    if (item_id && this.employeeList.length > 0) {
      let fitem: any = _.find(this.employeeList, { userid: item_id }),
        ref_name = fitem.username ? fitem.username : "";
      this.getUserMenus(item_id);
      return ref_name;
    }
    return "";
  }

  filterHa(name: string) {
    name = _.escapeRegExp(name);
    return this.employeeList.filter(
      ha =>
        new RegExp(name, "gi").test(ha.username) ||
        new RegExp(name, "gi").test(ha.fullname)
    );
  }

  getUserMenus(id) {
    let that = this;
    this.currentSelectedUserId = id;
    this.commonService.getUserMenus(id).then(res => {
      that.setData(res.data);
    });
  }

  setData(cur) {
    let that = this;
    that.fullMenus.map(fRes => {
      fRes['showMenu'] = false;
      cur.map(res => {
        if (res.menu_id == fRes.menu_id) {
          fRes['showMenu'] = true;
        }
      });
    });
    that.allMenuList = that.formatMenus(that.fullMenus);
  }

  prepareMenus(allMenus) {
    let that = this;
    allMenus.map(res => {
      if (res.sub) {
        that.prepareMenus(res.sub)
      } else {
        if (res['showMenu']) {
          that.menuIds.push(res.menu_id);
        }
      }
    });
    return that.menuIds;
  }

  saveDetail() {
    let that = this;
    this.menuIds = [];
    const menuIds = this.prepareMenus(this.allMenuList);
    if (menuIds.length == 0) {
      swal('ERROR', 'Please select any one Menu', 'error');
      return false;
    }

    swal({
      title: "CONFIRMATION",
      type: "warning",
      text: "Are You Sure want to menu mapping to this User?",
      confirmButtonText: 'Yes',
      showCancelButton: true,
    }).then(res => {
      this.menuIds = [];
      let param = {
        menuId: JSON.stringify(menuIds),
        userId: this.currentSelectedUserId
      };
      this.commonService.saveMenuMapping(param).then(res => {
        if (res.success) {
          that.getUserMenus(that.currentSelectedUserId);
          swal("SUCCESS", "Menu Mapped Successfully");
        } else {
          swal("ERROR", res.message);
        }
      });
    }, () => {
      console.log('Closed');
    });
  }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/menuMapping/menuMapping.component.ts